// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { BankUploadForm } from '@client/banks/types/create-bank-form';
import type { BankUploadListSection } from '@client/banks/types/bank-list-editor';

/**
 * Returns the list rows for a wizard section from {@link BankUploadForm}.
 *
 * @param formData - Current wizard aggregate state.
 * @param section - List section (`accounts`, `positions`, `debts`, `transactions`).
 */
export const getBankUploadListItems = (
  formData: BankUploadForm,
  section: BankUploadListSection,
) => {
  switch (section) {
    case 'accounts':
      return formData.accounts;
    case 'positions':
      return formData.positions ?? [];
    case 'debts':
      return formData.debts ?? [];
    case 'transactions':
      return formData.transactions ?? [];
  }
};
